import CollapsibleContent from './collapsible-content';

export default CollapsibleContent;
